export const userRole = {
  superAdmin: "superAdmin",
  installer: "installer",
  admin: "admin",
  user: "user",
  public: "public",
};
